import styled from "styled-components";

export const DateStripContainer = styled.div`
  display: flex;
  margin-left: 13px;
  margin-right: -51px;
`;

export const DateStripDaysContainer = styled.div`
  display: flex;
    
  .day-strip-day:last-child {
    border-right: solid 1px;
  }
`;

export const DayContainer = styled.div<{ isWeekend: boolean, lite?: boolean, width: number }>`
  max-width: ${props => props.width + "px"};
  min-width: ${props => props.width + "px"};
  height: ${props => props.lite ? "75px" : "auto"};
  border-top: solid 1px;
  border-left: solid 1px;
  border-bottom: solid 1px;
  background-color: ${({ theme, isWeekend }) => isWeekend ? theme.blueBackground : theme.greyBackground};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;    
  padding: ${props => props.lite ? 0 : "5px 20px"};
  font-size: 30px;
  border-color: ${({ theme }) => theme.greyBorderDark};
  & > div:first-child {
    font-size: 12px;
    margin-bottom: -10px;
  }
  & > div:nth-child(2) {
    font-weight: 500;
  }
  & > div:last-child {
    font-size: 12px;
    margin-top: -5px;
  }
`;

export const Navigation = styled.div`
  max-width: 67px;
  min-width: 67px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  & > button {
    color: ${({ theme }) => theme.regularTextColor};
    cursor: pointer;
    outline: none;
    border: 0;
    background-color: transparent;
    padding: 0;
  }
`;
